// Cache the uiKey for each label and key combination
// This is used to prevent constant re-rendering of the same field
const labelUiKeyCache = {};
export class UIField {
    label;
    key;
    group;
    metadataKey;
    isExtraField;
    rules;
    component;
    vOn;
    vBind;
    colSpan;
    isExtraData;
    defaultValue;
    hidden;
    context;
    onMounted;
    onAttributeChange;
    warnings;
    getValue;
    uiKey;
    constructor({ label, key, group, metadataKey, isExtraField, rules = [], component = "v-text-field", vOn = {}, vBind = {}, colSpan = 12, isExtraData = false, defaultValue = "", hidden = false, context = {}, onMounted = null, onAttributeChange = null, warnings = [], getValue = null, }) {
        this.label = label;
        this.key = key;
        this.group = group;
        this.metadataKey = metadataKey;
        this.isExtraField = isExtraField;
        this.rules = rules;
        this.component = component;
        this.vOn = vOn;
        this.vBind = vBind;
        this.colSpan = colSpan;
        this.isExtraData = isExtraData;
        if (component === "text-date-input" && !(defaultValue instanceof Date)) {
            this.defaultValue = null;
        }
        else {
            this.defaultValue = defaultValue;
        }
        this.hidden = hidden;
        this.context = context;
        this.onMounted = onMounted;
        this.onAttributeChange = onAttributeChange;
        this.warnings = warnings;
        this.getValue = getValue;
        this.uiKey = labelUiKeyCache[`${label}.${key}`] || this.key;
    }
    forceRedraw() {
        this.uiKey = `${this.key}-${Math.random()}`;
        labelUiKeyCache[`${this.label}.${this.key}`] = this.uiKey;
    }
}
export class UIFieldList {
    fields;
    _fieldsMap;
    constructor(fields) {
        this.fields = fields;
        this._fieldsMap = new Map(fields.map((field) => [field.key, field]));
    }
    getField(key) {
        return this._fieldsMap.get(key);
    }
    forGroup(group) {
        return this.fields.filter((field) => field.group === group);
    }
    addRule(fieldKeys, rule, position = -1) {
        fieldKeys.forEach((fieldKey) => {
            const f = this.getField(fieldKey);
            if (f && !f.rules.includes(rule)) {
                if (position === -1) {
                    f.rules.push(rule);
                }
                else {
                    f.rules = [...f.rules.slice(0, position), rule, ...f.rules.slice(position)];
                }
            }
        });
    }
    renameFields(renameMap) {
        Object.keys(renameMap).forEach((key) => {
            const field = this.getField(key);
            if (field) {
                field.label = renameMap[key];
            }
        });
    }
    setSelectableFields(selectableMap) {
        Object.keys(selectableMap).forEach((key) => {
            const field = this.getField(key);
            if (field) {
                field.component = "v-select";
                field.vBind.items = selectableMap[key];
            }
        });
    }
}
